document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-starterkit-launch-offer]').forEach(function (offer) {
    var endDate = new Date(offer.dataset.endDate);
    var countdown = offer.querySelector('[data-starterkit-countdown]');

    if (!countdown || Number.isNaN(endDate.getTime())) return;

    var updateCountdown = function () {
      var distance = endDate.getTime() - Date.now();

      if (distance <= 0) {
        countdown.hidden = true;
        offer.classList.add('starterkit-launch-offer--expired');
        return;
      }

      var units = {
        days: Math.floor(distance / 86400000),
        hours: Math.floor((distance % 86400000) / 3600000),
        minutes: Math.floor((distance % 3600000) / 60000),
        seconds: Math.floor((distance % 60000) / 1000)
      };

      Object.keys(units).forEach(function (unit) {
        var target = countdown.querySelector('[data-countdown-' + unit + ']');
        if (target) target.textContent = String(units[unit]).padStart(2, '0');
      });
    };

    updateCountdown();
    window.setInterval(updateCountdown, 1000);
  });
});
